import config,{ setConfig } from "./config/index.js";
import error from "./error/index.js";
import performance from "./performance/index.js";
import api from "./api/index.js";

let isInit = false;
const monitor = {
  init(options = {}) {
    setConfig(options); //配置全局参数
    // 多次初始化只执行一次挂载监听的逻辑
    if(!isInit){
      error(); //错误监听处理
      performance(); //性能监控
      api(); //api远程请求数据采集
      isInit = true;
    }
  },
};

export default monitor;
